import { gql } from "@apollo/client";

const getRatingsQuery = gql`
  query getRatingsQuery {
    ratings {
      edges {
        node {
          id
          title
        }
      }
    }
  }
`;

export default getRatingsQuery;
